import { chartColors } from '../../../Common/Charts/enums/chart-colors.enum';

/* eslint-disable @typescript-eslint/naming-convention */
export const defaultSocialColorMap = {
    '0': chartColors.agprBlue,
    '1': chartColors.agprPurple,
    '2': chartColors.agprLightBlue,
    '3': chartColors.agprOrange,
    '4': chartColors.agprYellow,
    '5': chartColors.agprLightGreen,
    '6': chartColors.agprGreen,
    '7': chartColors.agprTeal,
    '8': chartColors.agprAqua,
    '9': chartColors.agprCoralPink,
    '10': chartColors.agprCrimson,
    '11': chartColors.agprLavender,
};
